import React from 'react';

const MongoDB_Exercises = () => {
  return (
    <div>
      <h1>MongoDB_Exercises Component</h1>
      <p>This is the MongoDB_Exercises page.</p>
    </div>
  );
};

export default MongoDB_Exercises;
